import { render, staticRenderFns } from "./KarsilastirmaliYilSecim.vue?vue&type=template&id=2b5f55a6"
import script from "./KarsilastirmaliYilSecim.vue?vue&type=script&lang=ts"
export * from "./KarsilastirmaliYilSecim.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports